import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import moveNode from '../actions/moveNode'
import getAllNodes from '../actions/getAllNodes'
import createSnackbar from 'modules/App/factories/createSnackbar'
import deselectNodesOnChange from '../chains/deselectNodesOnChange'

export default [
  moveNode,
  getAllNodes,
  {
    loaded: [
      ...deselectNodesOnChange,
      set(state`node.nodes`, props`nodes`),
      set(state`node.rebuildTree`, true)
    ]
  },
  createSnackbar({ key: 'bms.node.moved' }, 'success')
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/moveNode.js